// Configures the generated API client: bearer token, active organization and language on every
// request; an auth.token_expired answer ends the session (authentication spec).
import { client } from "@manapp/api-client"

import type { AuthController } from "./auth/session"

type ApiContext = { controller: AuthController | null; organizationId: string | null; language: string }

const context: ApiContext = { controller: null, organizationId: null, language: "en" }

export function setApiController(controller: AuthController): void {
  context.controller = controller
}

export function setActiveOrganization(organizationId: string | null): void {
  context.organizationId = organizationId
}

export function setApiLanguage(language: string): void {
  context.language = language
}

export type Problem = { code: string; title?: string; status?: number; correlation_id?: string }

export function isProblem(value: unknown): value is Problem {
  return typeof value === "object" && value !== null && typeof (value as { code?: unknown }).code === "string"
}

let configured = false

export function configureApi(fetchImpl?: typeof fetch): void {
  // Same-origin API (Caddy proxies /api); an absolute base also works outside browsers (tests).
  client.setConfig({ baseUrl: window.location.origin, ...(fetchImpl ? { fetch: fetchImpl } : {}) })
  if (configured) return
  configured = true
  client.interceptors.request.use(async (request) => {
    if (context.controller) request.headers.set("Authorization", `Bearer ${await context.controller.accessToken()}`)
    if (context.organizationId) request.headers.set("X-Organization-Id", context.organizationId)
    request.headers.set("Accept-Language", context.language)
    return request
  })
  client.interceptors.response.use(async (response) => {
    if (response.status === 401 && context.controller) {
      const body: unknown = await response.clone().json().catch(() => null)
      if (isProblem(body) && ["auth.token_expired", "auth.token_invalid", "auth.token_missing"].includes(body.code)) {
        await context.controller.expire()
      }
    }
    return response
  })
}
